import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SummaryBackendServer extends BaseBackend {

  getSummaryByDealer(builder): Observable<any> {
    return this.get('/summary/dealer', { params: builder });
  }

  getSummaryByAgent(builder): Observable<any> {
    return this.get('/summary/agent', { params: builder });
  }
}
